import type { ServiceArea } from '@/types'

export const DISPATCH_NOTE = "Every truck rolls out of our Foundry Street yard in Riverton at 7 AM."

export const serviceAreas: ServiceArea[] = [
    {
        slug: 'oak-hollow',
        name: "Oak Hollow",
        zips: ['40114'],
        arrival: "1 h 50 min",
        arrivalMinutes: 110,
        intro: "More than 640 Oak Hollow doors have passed through our hands, most of them two-car steel doors from the 1990s around Briar Park and Mill Creek.",
        doorsServiced: "640+",
        quote: {
            text: "Spring replaced in 48 minutes, and they showed me the worn cable before swapping it.",
            author: "Customer, Briar Park, Oak Hollow"
        },
        position: { x: 246.6, y: 144.5 }
    },
    {
        slug: 'riverton',
        name: "Riverton",
        zips: ['40110', '40111'],
        arrival: "1 h 20 min",
        arrivalMinutes: 80,
        intro: "Riverton is home turf. Our dispatch yard sits on Foundry Street, so this is where we reach you fastest.",
        position: { x: 200, y: 200 }
    },
    {
        slug: 'millbrook',
        name: "Millbrook",
        zips: ['40117'],
        arrival: "2 h 05 min",
        arrivalMinutes: 125,
        intro: "Spring snaps, sticky openers and full door replacements across Millbrook (40117), with urgent visits usually arriving in about 2 h 05 min.",
        position: { x: 292.6, y: 216.4 }
    },
    {
        slug: 'fairhaven',
        name: "Fairhaven",
        zips: ['40120'],
        arrival: "2 h 10 min",
        arrivalMinutes: 130,
        intro: "From quick repairs to new insulated doors, we look after homes across Fairhaven (40120). Urgent visits usually arrive in about 2 h 10 min.",
        position: { x: 250.8, y: 287.9 }
    },
    {
        slug: 'stonebridge',
        name: "Stonebridge",
        zips: ['40123'],
        arrival: "2 h 30 min",
        arrivalMinutes: 150,
        intro: "Homes and workshops across Stonebridge (40123) call us for repairs, new doors and commercial work. Urgent visits usually arrive in about 2 h 30 min.",
        position: { x: 155.4, y: 322.6 }
    },
    {
        slug: 'ashford-park',
        name: "Ashford Park",
        zips: ['40126'],
        arrival: "2 h 15 min",
        arrivalMinutes: 135,
        intro: "Repairs, openers and new carriage-house doors across Ashford Park (40126), with urgent visits usually arriving in about 2 h 15 min.",
        position: { x: 97.8, y: 237.2 }
    },
    {
        slug: 'lakeview-heights',
        name: "Lakeview Heights",
        zips: ['40129'],
        arrival: "2 h 40 min",
        arrivalMinutes: 160,
        intro: "Lakeview Heights (40129) is at the far edge of our map, and we still come out for every repair and new door. Urgent visits usually arrive in about 2 h 40 min.",
        position: { x: 74.4, y: 127.5 }
    },
    {
        slug: 'pine-ridge',
        name: "Pine Ridge",
        zips: ['40132'],
        arrival: "2 h 50 min",
        arrivalMinutes: 170,
        intro: "Repairs, smart openers and new doors for Pine Ridge (40132), the furthest town on our routes. Urgent visits usually arrive in about 2 h 50 min.",
        position: { x: 158.7, y: 45.9 }
    }
]

export const getAreaBySlug = (slug: string): ServiceArea | undefined =>
    serviceAreas.find(area => area.slug === slug)

export const findAreaByZip = (zip: string): ServiceArea | undefined =>
    serviceAreas.find(area => area.zips.includes(zip.trim()))
